module.exports = __webpack_public_path__ + "static/media/usa-dian.a4d0b2af.png";